webpackJsonp([263791100135453],{

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(14);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Header = __webpack_require__(16);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(15);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _gatsbyImage = __webpack_require__(42);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Header2.default, { data: data }),
	    _react2.default.createElement(
	      "main",
	      null,
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: data.background.sizes }),
	      _react2.default.createElement(
	        "div",
	        { className: "wrap" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "column large-8" },
	            _react2.default.createElement(
	              "h1",
	              null,
	              "About"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Hello, my name is ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://www.linkedin.com/in/lee-murray-05706562/" },
	                "Lee Murray"
	              ),
	              ", welcome to the digital coalface."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "I created the digital coalface with the aim to help people working in digital improve themselves by discussing important topics within the industry and providing useful resources."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Working in digital in 2018 is more challenging than ever, with this in mind I wanted to create something that would help colleagues in their day to day jobs even if it's just a point discussed or a resource link shared."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "I also wanted to try to improve myself, push out of my comfort zone, speaking on a podcast was high on the list of things that would make me uncomfortable."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "I hope you can bear with me on the podcasts, I\u2019m hoping at some point I will find my voice, my vocabulary and get better but please send any feedback you may have on how we could improve the format to ",
	              _react2.default.createElement(
	                "a",
	                { href: "mailto:thedigitalcoalface@gmail.com" },
	                "thedigitalcoalface@gmail.com"
	              ),
	              "."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "I'm a Manchester based interaction designer with over 17 years commercial experience and am currently helping co-op digital improve their digital offerings."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "My personal twitter is ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://twitter.com/uxeskimo" },
	                "@uxeskimo"
	              ),
	              " and my own website is ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://uxeskimo.co.uk" },
	                "www.uxeskimo.co.uk"
	              ),
	              "."
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { data: data })
	  );
	};
	
	exports.default = About;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-f38cf7511b34b7b2050b.js